import React from 'react';

export class Textfield extends React.Component {
  constructor (props) {
    super(props);
    this.state = { value: '', hasValue: false };
  }

  componentDidMount () {
    if (this.props.focus) this.field.focus();
  }

  get hasValue () {
    return this.field && this.field.value && this.field.value.length > 0;
  }

  get value () {
    return this.state.value;
  }

  update = (e) => {
    this.setState({
      value: e.currentTarget.value,
      hasValue: e.currentTarget.value.length > 0
    })
  }

  render () {
    return (
      <div className="textfield">
        <input
          type={ this.props.secure ? 'password' : 'text' }
          className={this.state.hasValue ? 'has-value' : ''}
          onChange={this.update}
          value={this.state.value}
          ref={_ => this.field = _}
          {...this.props} />
        <label className="typo-body">{ this.props.label }</label>
      </div>
    );
  }
}
